import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderModel } from '../models/order.model';

export class OrdersApiService extends ApiService {
  static endpoint = 'orders';

  /**
   * @param {Number|null} order
   * @return {String}
   * @protected
   */
  static buildOrderUrl(order = null) {
    return this.buildUrl(order);
  }

  /**
   * @param {String|Number} order
   * @param {builderCallback} callback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderModel>>}
   * @public
   */
  static async get(order, callback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderUrl(order), {
      ...config,
      dataModel: OrderModel,
      params: this.prepareUrlBuilder(callback).getUrlParameters(),
    });
  }

  /**
   * @param {String} order
   * @param {builderCallback|null} callback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderModel>>}
   * @public
   */
  static getAll(callback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderUrl(), {
      ...config,
      dataModel: OrderModel,
      params: this.prepareUrlBuilder(callback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} callback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderModel>>}
   * @public
   */
  static async post(data, callback = null, config = {}) {
    return HttpApiClient.post(this.buildOrderUrl(), data, {
      ...config,
      dataModel: OrderModel,
      params: this.prepareUrlBuilder(callback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} order
   * @param {Object} data
   * @param {builderCallback} callback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderModel>>}
   * @public
   */
  static async patch(order, data = {}, callback = null, config = {}) {
    return HttpApiClient.patch(this.buildOrderUrl(order), data, {
      ...config,
      dataModel: OrderModel,
      params: this.prepareUrlBuilder(callback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} order
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(orderState, config = {}) {
    return HttpApiClient.delete(this.buildOrderStateUrl(orderState), { ...config });
  }
}
